import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { useAuth } from '@/contexts/AuthContext';

interface UserInfoProps {
	className?: string;
}

export const UserInfo: React.FC<UserInfoProps> = ({ className }) => {
	const { user, isLoading } = useAuth();

	if (isLoading) {
		return (
			<div className={cn('flex items-center gap-3', className)}>
				<Skeleton className="h-10 w-10 rounded-full" />
				<div className="flex h-10 flex-col justify-between">
					<Skeleton className="h-4 w-32" />
					<Skeleton className="h-4 w-24" />
				</div>
			</div>
		);
	}

	if (!user) {
		return (
			<div
				className={cn(
					'flex flex-col gap-1 text-sm text-slate-200',
					className
				)}
			>
				<span className="font-semibold">Guest</span>
				<span className="text-xs text-slate-400">Not signed in</span>
			</div>
		);
	}

	return (
		<div className={cn('flex items-center gap-3', className)}>
			<div className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-600 ring-2 ring-slate-500/50 text-sm font-medium text-slate-200">
				{user.username?.charAt(0).toUpperCase() || 'U'}
			</div>
			<div className="flex flex-col gap-0.5">
				<span className="text-sm font-medium text-slate-200">
					{user.username || 'User'}
				</span>
				<span className="text-xs text-slate-400">{user.email}</span>
			</div>
		</div>
	);
};

UserInfo.displayName = 'UserInfo';
